/**
 * Sidebar-shell layout for authenticated admin pages.
 * Renders the child route via <Outlet />.
 */
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutGrid, Users, Radio, Settings as SettingsIcon, LogOut } from "lucide-react";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutGrid, end: true },
    { to: "/admin/collaboratori", label: "Collaboratori", icon: Users },
    { to: "/admin/tag", label: "Tag NFC", icon: Radio },
    { to: "/admin/impostazioni", label: "Impostazioni", icon: SettingsIcon },
];

export default function AdminLayout({ user, onLogout }) {
    const loc = useLocation();
    return (
        <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="admin-shell">
            <aside className="fixed inset-y-0 left-0 w-60 bg-white border-r border-slate-200 flex flex-col">
                <Link
                    to="/admin"
                    className="px-6 pt-6 pb-4 border-b border-slate-100"
                    data-testid="admin-brand-link"
                >
                    <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500">Spazio Marconi</div>
                    <div className="text-base font-semibold">Recensioni Google</div>
                </Link>
                <nav className="flex-1 py-4">
                    {NAV.map(({ to, label, icon: Icon, end }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={end}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-6 py-2.5 text-sm transition ${
                                    isActive
                                        ? "bg-slate-900 text-white"
                                        : "text-slate-700 hover:bg-slate-100"
                                }`
                            }
                            data-testid={`nav-${to.replace(/^\/admin\/?/, "") || "dashboard"}`}
                        >
                            <Icon size={16} strokeWidth={1.7} />
                            <span>{label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-6 border-t border-slate-100 text-xs text-slate-500">
                    <div className="truncate mb-2" title={user?.email}>{user?.email}</div>
                    <button
                        onClick={onLogout}
                        className="flex items-center gap-2 text-slate-700 hover:text-red-600 transition"
                        data-testid="admin-logout"
                    >
                        <LogOut size={14} strokeWidth={1.7} />
                        Esci
                    </button>
                </div>
            </aside>
            <main
                key={loc.pathname}
                className="ml-60 min-h-screen p-8 md:p-10"
                data-testid="admin-main"
            >
                <Outlet />
            </main>
        </div>
    );
}
